import React, { useState } from 'react';
import Styles from './credit-summary-styles.scss';
import { CreditCardScore, IconButton } from '@/presentation/components';
import { MoreInfoIcon } from '@/presentation/components/icons';
import CreditScoreText from '@/presentation/components/credit-card-score/credit-score-text';
const CreditSummary = ({ balance, availableCredit, creditScore, statementDate, minimumPayment, interestRate }) => {
    const [showCreditScore, setShowCreditScore] = useState(false);
    return (React.createElement("div", { className: Styles.creditSummary },
        React.createElement("div", { className: Styles.creditSummaryRow },
            React.createElement("div", { className: Styles.creditSummaryItem },
                React.createElement("div", { className: Styles.creditSummaryLabel }, "Balance"),
                React.createElement("div", { className: Styles.balance }, balance)),
            React.createElement("div", { className: Styles.creditSummaryItem },
                React.createElement("div", { className: Styles.creditSummaryLabel }, "Available Credit"),
                React.createElement("div", { className: Styles.availableCredit }, availableCredit)),
            React.createElement("div", { className: Styles.creditSummaryItem },
                showCreditScore && React.createElement(CreditCardScore, { score: creditScore, close: () => setShowCreditScore(false) }),
                React.createElement("div", { className: Styles.creditSummaryLabel },
                    "Credit Score",
                    React.createElement(IconButton, { onClick: () => {
                            setShowCreditScore(true);
                        } },
                        React.createElement(MoreInfoIcon, null))),
                React.createElement(CreditScoreText, { score: creditScore }))),
        React.createElement("div", { className: Styles.creditSummaryRow },
            React.createElement("div", { className: Styles.creditSummaryItem },
                React.createElement("div", { className: Styles.creditSummaryLabel }, "Statement Date"),
                React.createElement("div", { className: Styles.statementDate }, statementDate)),
            React.createElement("div", { className: Styles.creditSummaryItem },
                React.createElement("div", { className: Styles.creditSummaryLabel }, "Minimum Payment"),
                React.createElement("div", { className: Styles.minimumPayment }, minimumPayment)),
            React.createElement("div", { className: Styles.creditSummaryItem },
                React.createElement("div", { className: Styles.creditSummaryLabel }, "Interest Rate"),
                React.createElement("div", { className: Styles.interestRate },
                    interestRate,
                    "%")))));
};
export default CreditSummary;
